/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1650
 */

require(/* 86 */"./86/index")({
  target: "Number",
  stat: true
}, {
  isFinite: require(/* 1651 */"./1651")
})
